import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import './globals.css';

import { Main } from './pages/Main';

const element = document.createElement('div');
document.body.appendChild(element);

const root = createRoot(element);
root.render(
  <BrowserRouter basename={import.meta.env.BASE_URL}>
    <Routes>
      <Route path="/examples/:page" element={<Main />} />
      <Route path="/" element={<Navigate to="/examples/readme" replace />} />
    </Routes>
  </BrowserRouter>,
);
